/** @jsx jsx */
import React, { useEffect, useState } from 'react'
import { jsx, useThemeUI } from 'theme-ui'

export const SimpleInput = React.forwardRef((props, ref) => {
  const {
    hasError,
    type,
    placeholder,
    onChange,
    name,
    defaultValue,
    prefix,
    suffix,
    inputSize,
    uppercase,
    onKeyDown,
  } = props
  const [hasFocus, setHasFocus] = useState(false)
  const [prefixWidth, setPrefixWidth] = useState(0)
  const [suffixWidth, setSuffixWidth] = useState(0)
  const prefixRef = React.createRef()
  const suffixRef = React.createRef()

  const additionalProps = () => {
    const defaultProps = [
      'hasError',
      'type',
      'placeholder',
      'onChange',
      'name',
      'defaultValue',
      'prefix',
      'suffix',
      'uppercase',
      'onKeyDown',
      'inputSize',
    ]

    let tempArr = {}
    Object.keys(props).forEach((key) => {
      if (!defaultProps.includes(key)) {
        tempArr = {
          ...tempArr,
          'aria-label': name,
          [key]: props[key],
        }
      }
    })
    return tempArr
  }

  useEffect(() => {
    setPrefixWidth(prefixRef?.current?.offsetWidth || 0)
    setSuffixWidth(suffixRef?.current?.offsetWidth || 0)
  }, [prefixRef, suffixRef])

  const setWidth = (inputSize) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { theme } = useThemeUI()
    const widthLookup = {
      sm: theme?.elements?.['simple-input']?.inputWidth?.small,
      base: '100%',
    }
    return inputSize ? widthLookup[inputSize] + prefixWidth + suffixWidth : widthLookup.base
  }

  return (
    <div
      onBlur={() => setHasFocus(false)}
      sx={{
        width: setWidth(inputSize),
        variant:
          hasError && !hasFocus
            ? 'elements.simple-input.variants.error'
            : hasFocus
            ? 'elements.simple-input.variants.focus'
            : 'elements.simple-input.wrapper',
      }}
    >
      <If condition={prefix}>
        <span ref={prefixRef} sx={{ variant: 'elements.simple-input.affix.prefix' }}>
          {prefix}
        </span>
      </If>

      <input
        sx={{
          variant: 'elements.simple-input.base',
          textAlign: inputSize === 'sm' ? 'center' : 'left',
          textTransform: uppercase && 'uppercase',
        }}
        placeholder={placeholder}
        ref={ref}
        onChange={onChange}
        defaultValue={defaultValue}
        onFocus={() => {
          setHasFocus(false)
          setHasFocus(true)
        }}
        onBlur={() => setHasFocus(false)}
        onKeyDown={onKeyDown}
        name={name}
        type={type || 'text'}
        {...additionalProps()}
      />

      <If condition={suffix}>
        <span ref={suffixRef} sx={{ variant: 'elements.simple-input.affix.suffix' }}>
          {suffix}
        </span>
      </If>
    </div>
  )
})
